import Utils from "./util";

import axios from "axios";
import { useUserStore } from "@/stores/modules/user";
import { $Toast, $ErrorToast } from "./util";
import router from "../router";
import { createI18nInstance } from "@/config";

const Http = axios.create({
  baseURL: import.meta.env.VITE_BASE_API,
  timeout: 5000
});
Http.interceptors.request.use(
  config => {
    // 动态设置请求头
    config.headers["lang"] = Utils.$storageGet("config").LANGUAGE_DEFAULT;
    config.headers["token"] = Utils.$storageGet("token") || "";
    return config;
  },
  error => {
    Promise.reject(error);
  }
);
Http.interceptors.response.use(
  async response => {
    
    // if (response.config.url === "Share/getParams") {
    //   console.log(response.config);
    // }
    // 是否提示错误信息
    const showError =
      response.config.meta && response.config.meta.showError !== undefined
        ? response.config.meta.showError
        : true;
    if (response.status === 200) {
      const res = response.data;
      switch (res.code) {
        case 200:
          // 成功
          return Promise.resolve(res);
        case 1:
          // 成功
          return Promise.resolve(res);
        case 401:
        case 422:
        case 100002:
          // Token失效
          const userStore = useUserStore();
          userStore.logout();
          router.push("/home");
          return Promise.reject(res);
        case 11010:
          // 今日充值额度不够
          return Promise.resolve(response);
          break;
        default:
          if (showError) {
            const i18n = await createI18nInstance();
            const { t } = i18n.global;
            // console.log(res)
            // $ErrorToast(`${t(res.code)}`);
            $ErrorToast(res.msg);
          }
          break;
      }
      return Promise.reject(response.data);
    } else {
      return Promise.reject(response.data);
    }
  },
  async error => {
    console.log(error);
    const showError =
      error.config && error.config.meta.showError !== undefined
        ? error.config.meta.showError
        : true;
    const status = error.response?.status;
    switch (status) {
      case 401:
        logoutHandle();
        break;
      case 422:
        logoutHandle();
        if (showError) {
          const msg =
            error.response?.data?.msg ||
            error.response?.data?.message ||
            "Request Error";

          $ErrorToast(msg);
        }
        break;

      default:
        if (showError) {
          if (error.code === "ECONNABORTED") {
            const i18n = await createI18nInstance();
            $ErrorToast(i18n.global.t("201"));
          } else {
            $ErrorToast(
              error.response?.data?.msg ||
              error.response?.data?.message ||
              error.message
            );
          }
        }
    }

    return Promise.reject(error);
  }
);
function logoutHandle() {
  const userStore = useUserStore();
  userStore.logout();
  Utils.$storageClear("token");
  Utils.$storageClear("userinfo");
  if (router.currentRoute.value.path !== "/login") {
    router.replace("/login");
  }
}
export default Http;
